import { i18n } from 'localization'
import { parseDate } from './utils'
import Document from './Document'
import { Laterality } from 'utils/enums'
import Transport from './Transport'
export default class Requisition {
	static fromJSON(json) {
		return new Requisition(
			json.id,
			json.appointmentId,
			json.clinicalProcessId,
			json.clinicalInformation,
			json.requestingAppointmentId
		)
			.withType(json.requisitionType)
			.withDates(
				json.requisitionDate,
				json.scheduledDate,
				json.executionDate,
				json.creationDate,
				json.relapseDate
			)
			.withStatus(json.requisitionStatus)
			.withRequestEscort(json.requestEscort)
			.withEstablishment(json.establishment)
			.withRequiringEstablishment(json.requiringEstablishment)
			.withApplicant(json.applicantEntity)
			.withMedicalActs(json.medicalActs)
			.withExams(json.exams)
			.withAppointment(json.appointment)
			.withAppointmentRequisition(json.appointmentRequisition)
			.withDocuments(json.documents)
			.withAdministrativeObservation(json.administrativeObservation)
			.withClinicalObservation(json.clinicalObservation)
			.withRequisitionObservation(json.observation)
			.withRefusalJustification(json.refusalJustification)
			.withProviderRefusalJustification(json.providerRefusalJustification)
			.withProviderDescription(json.providerDescription)
			.withSpecialty(json.specialty)
			.withSurgicalRequest(json.surgicalRequestAdmission)
			.withMaterials(json.surgicalMaterials)
			.withClinicalInformation(json.clinicalInformation)
			.withNotes(json.notes)
			.withTrustCoordinatorMedic(json.trustCoordinatorMedic)
			.withChargeAmounts(
				json.amountChargedToTrust,
				json.amountChargedToAthlete,
				json.expectedValue
			)
			.withTransport(json.transport)
			.withPrescribingDoctor(json.prescribingDoctor)
			.withPhysiotherapyData(json.physiotherapyData)
			.withCreationUser(json.creationUser)
			.withUrgency(json.urgency)
			.withDistrict(json.district)
			.withOutsideNetwork(json.outsideNetwork)
			.withTstAppointment(json.tstAppointment)
			.withComments(json.comments)
			.withNonExecutionMotive(json.nonExecutionMotive)
			.withTransports(json.transportList)
			.withAlternativeAddress(json)
			.withObservations(json)
	}

	constructor(
		id,
		appointmentId,
		clinicalProcessId,
		clinicalInformation,
		requestingAppointmentId
	) {
		this.id = id?.toString()
		this.appointmentId = appointmentId
		this.requestingAppointmentId = requestingAppointmentId ?? null
		this.processId = clinicalProcessId
		this.key = `requisition_${id || ''}`
		this.textId = `requisition_${id || ''}`
		this.anchorId = `R_${id || ''}`
		this.text = clinicalInformation
	}

	withAlternativeAddress(json) {
		this.alternativeAddress = json.alternativeAddress
			? json.alternativeAddressDescription
			: null

		return this
	}

	withObservations(json) {
		this.observations = json.observations ? json.observations : null

		return this
	}

	withTransports(transports) {
		this.transports =
			transports && transports.length
				? transports.map(Transport.fromJson)
				: []
		return this
	}

	withDates(
		requisitionDateStr,
		scheduledDateStr,
		executionDateStr,
		creationDateStr,
		relapseDateStr
	) {
		this.requisitionDate = requisitionDateStr
			? parseDate(requisitionDateStr)
			: {}
		this.scheduledDate = scheduledDateStr ? parseDate(scheduledDateStr) : {}
		this.executionDate = executionDateStr ? parseDate(executionDateStr) : {}
		this.creationDate = creationDateStr ? parseDate(creationDateStr) : {}
		this.relapseDate = relapseDateStr ? parseDate(relapseDateStr) : {}
		return this
	}

	withStatus(json) {
		this.status = json?.value
			? {
					id: json.id,
					value: json.value,
					description: json.description,
					icon:
						json.value === 'UNKNOWN'
							? 'cancelled'
							: json.value.toLowerCase().replace('_', '-'),
			  }
			: null
		return this
	}

	withRequestEscort(value) {
		if (value !== undefined && value !== null) {
			this.requestEscort = !!value
		}
		return this
	}

	withType(json) {
		this.type = json
			? {
					id: json.id,
					name: i18n.translate((json.name || '').trim()),
					// color: stringToHslColor(json.name.slice(0, 6), undefined, 40),
					// backgroundColor: stringToHslColor(json.name.slice(0, 6), 10, 94)
			  }
			: null
		return this
	}
	withEstablishment(json) {
		this.establishment = json
			? {
					id: json.id,
					name: json.name,
					outsideNetwork: json.outsideNetwork,
			  }
			: null
		return this
	}
	withRequiringEstablishment(json) {
		this.requiringEstablishment = json
			? {
					id: json.id,
					name: json.name,
			  }
			: null
		return this
	}
	withProvider(json) {
		this.provider = json
			? {
					id: json.id,
					name: json.name,
					outsideNetwork: json.outsideNetwork,
			  }
			: null
		return this
	}
	withApplicant(json) {
		this.applicant = json
			? {
					id: json.id,
					name: json.name,
			  }
			: null
		return this
	}

	withMedicalActs(json) {
		this.medicalActs =
			json && json.length
				? json.map((actJson) => {
						return {
							id: parseInt(actJson.id, 10),
							medicalActId: actJson.medicalAct?.medicalActId,
							name: actJson.description,
							code: actJson.code,
							requestedQuantity: actJson.requestedQuantity || 0,
							approvedQuantity: actJson.approvedQuantity || 0,
							executedQuantity: actJson.executedQuantity || 0,
							approved:
								actJson.requestedQuantity ===
								actJson.approvedQuantity,
							partialApproved:
								actJson.approvedQuantity > 0 &&
								actJson.requestedQuantity !==
									actJson.approvedQuantity,
							rejected: !actJson.approvedQuantity,
							kValue: actJson.kValue,
							percentage: actJson.percentage,
							refused: actJson.refuse || actJson.refused,
							laterality: actJson.leftLaterality
								? Laterality.Left
								: actJson.rightLaterality
								? Laterality.Right
								: Laterality.NotApplicable,
						}
				  })
				: null
		return this
	}
	withExams(json) {
		this.exams =
			json && json.length
				? json.map((actJson) => ({
						id: parseInt(actJson.id),
						name: actJson.description,
						code: actJson.code,
						refuse: actJson.refuse,
						rejected: actJson.rejected,
				  }))
				: null
		return this
	}
	withAppointment(json) {
		if (json) {
			const date = json.dateTime ? parseDate(json.dateTime) : null
			this.appointment = {
				id: json.id,
				name: json.name,
				doctor: json.doctor || null,
				medicalSpecialty: json.medicalSpecialty,
				transport: json.transport,
				establishment: json.establishment,
				date,
				nextAppointment: json.nextAppointmentDate
					? parseDate(json.nextAppointmentDate)
					: null,
			}
		} else {
			this.appointment = null
		}
		return this
	}

	withAppointmentRequisition(json) {
		if (json) {
			const date = json.appointmentDatetime
				? parseDate(json.appointmentDatetime)
				: null
			this.appointmentRequisition = {
				doctor: json.doctor || null,
				medicalSpecialty: json.medicalSpecialty,
				date,
			}
		} else {
			this.appointmentRequisition = null
		}
		return this
	}

	withDocuments(json) {
		this.documents = (json || []).map((doc) => Document.fromJSON(doc))
		if (this.documents) {
			this.documentsOptions = this.documents.map((doc) => ({
				id: doc.id,
				name: doc.name,
				value: doc.id,
				text: doc.type?.name || doc.name,
			}))
		}
		this.hasDocuments = !!this.documents.length
		return this
	}

	withAdministrativeObservation(administrativeObservation) {
		this.administrativeObservation = administrativeObservation
		return this
	}

	withClinicalObservation(clinicalObservation) {
		this.clinicalObservation = clinicalObservation
		return this
	}

	withRequisitionObservation(requisitionObservation) {
		this.requisitionObservation = requisitionObservation
		return this
	}

	withRefusalJustification(refusalJustification) {
		this.refusalJustification = refusalJustification
		return this
	}

	withProviderRefusalJustification(providerRefusalJustification) {
		this.providerRefusalJustification = providerRefusalJustification
		return this
	}

	withSpecialty(json) {
		this.specialty = json
			? {
					id: json.id,
					name: json.name,
			  }
			: null
		return this
	}

	withSurgicalRequest(json) {
		this.surgicalRequestAdmission = json
			? {
					surgeryType: {
						...json.surgeryType,
					},
					surgeryDate: json.surgeryDate
						? parseDate(json.surgeryDate)
						: null,
					needsOperatingRoom: json.needsOperatingRoom ? 'Yes' : 'No',
					admissionDays: json.admissionDays,
					admissionDate: json.admissionDate
						? parseDate(json.admissionDate)
						: null,
					observations: json.observations,
					intervenients: {
						surgeon: {
							...json.surgeon,
							percentage: json.surgeonPercentage,
						},
						medicAssistant: {
							...json.medicAssistant,
							percentage: json.medicAssistantPercentage,
						},
						anesthesiologist: {
							name: json.anesthesiologistName,
							percentage: json.anesthesiologistPercentage,
						},
						instrumentalist: {
							name: json.instrumentalistName,
							percentage: json.instrumentalistPercentage,
						},
						other: {
							name: json.otherMedicName,
							percentage: json.otherPercentage,
						},
					},
			  }
			: null
		return this
	}

	withMaterials(surgicalMaterials) {
		this.materials = surgicalMaterials
		return this
	}

	withClinicalInformation(value) {
		this.clinicalInformation = value
		return this
	}

	withNotes(value) {
		this.notes = value
		return this
	}

	withTrustCoordinatorMedic(json) {
		this.trustCoordinatorMedic = json ? { name: json.name } : null
		return this
	}

	withChargeAmounts(
		amountChargedToTrust,
		amountChargedToAthlete,
		expectedValue
	) {
		this.amountsToCharge = {
			amountChargedToTrust,
			amountChargedToAthlete,
			expectedValue,
		}
		return this
	}

	withProviderDescription(providerDescription) {
		this.providerDescription = providerDescription
		return this
	}

	withTransport(transport) {
		this.transport = transport?.transportType
		return this
	}

	withPrescribingDoctor(prescribingDoctor) {
		this.prescribingDoctor = prescribingDoctor?.name
		return this
	}

	withPhysiotherapyData(physiotherapyData) {
		this.physiotherapyData = {
			...physiotherapyData,
			surgeryDate: physiotherapyData?.surgeryDate
				? parseDate(physiotherapyData.surgeryDate)
				: null,
			orthosesFrom: physiotherapyData?.orthosesFrom
				? parseDate(physiotherapyData.orthosesFrom)
				: null,
			partialWeaning: physiotherapyData?.partialWeaning
				? parseDate(physiotherapyData.partialWeaning)
				: null,
			totalWeaning: physiotherapyData?.totalWeaning
				? parseDate(physiotherapyData.totalWeaning)
				: null,
		}
		return this
	}

	withCreationUser(creationUser) {
		this.creationUser = creationUser?.membership?.fullname
		return this
	}

	withUrgency(urgency) {
		this.urgency = urgency
		return this
	}

	withDistrict(district) {
		this.district = district
		return this
	}

	withOutsideNetwork(outsideNetwork) {
		this.outsideNetwork = outsideNetwork
		return this
	}

	withTstAppointment(tstAppointment) {
		this.tstAppointment = {
			serviceProvider: tstAppointment?.establishment?.name,
			appointmentDate: tstAppointment?.dateTime
				? parseDate(tstAppointment.dateTime)
				: null,
			specialty: tstAppointment?.medicalSpecialty?.name,
			transport: tstAppointment?.transport,
			doctor: tstAppointment?.doctor?.name,
			observation: tstAppointment?.observation,
		}
		return this
	}

	withComments(comments) {
		this.comments = comments && comments.length ? comments : null

		return this
	}

	withNonExecutionMotive(nonExecutionMotive) {
		this.nonExecutionMotive = nonExecutionMotive
		return this
	}
}
